/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import navbarSearchAndPinListCandidat from "@/layouts_candidat/components/navbar/navbarSearchAndPinList"
import navbarSearchAndPinListFormateur from "@/layouts_formateur/components/navbar/navbarSearchAndPinList"

import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  avatar    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin"
}
//console.log("localStorage",localStorage)
const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}
//console.log("userInfoLocalStorage",userInfoLocalStorage)
// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}
  console.log("userInfo0",userInfo.permission)
  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })
  console.log("userInfo1",userInfo)
  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })
  console.log("userInfo2",userInfo)
  return userInfo
  
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : getUserInfo(),
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    navbarSearchAndPinListCandidat  : navbarSearchAndPinListCandidat,
    navbarSearchAndPinListFormateur  : navbarSearchAndPinListFormateur,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    starredPagesCandidat    : navbarSearchAndPinListCandidat["pages"].data.filter((page) => page.is_bookmarked),
    starredPagesFormateur   : navbarSearchAndPinListFormateur["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    //////web
    mainLayoutTypeweb          :  "horizontal",
}

export default state
